import React, { useEffect, useState } from 'react';
import { Button, Grid, MenuItem, Modal, Select } from '@material-ui/core';

import { logisticsApi as api } from 'api/logistics';
import { DataTable, FormComponent, Notifications } from 'shared';

function DBICrossDocks({ data }) {
    const [rows, setRows] = useState(data || []);
    const [notification, setNotification] = useState({ text: null, level: null });

    const getRows = async () => {
        const res = await api.getDBICrossDocks();
        if (res.status) {
            setRows(res.data.rows);
        }
    };

    const saveEdit = async ({ field, id, value }) => {
        const item = { [field]: value };
        const response = await api.updateCrossDock(id, item);
        if (response.status === false) {
            let message = 'Error modifying cross dock';
            if (response) {
                message += `: ${response.msg}`;
            }
            setNotification({ text: message, level: 'error' });
        } else {
            setNotification({ text: 'Cross dock modified!', level: 'success' });
            await getRows();
        }
        return response.status;
    };

    useEffect(() => {
        getRows();
    }, []);

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'hub', Header: 'Hub' },
        { accessor: 'lineOne', Header: 'Line One' },
        { accessor: 'city', Header: 'City' },
        { accessor: 'province', Header: 'State' },
        { accessor: 'zip', Header: 'Zip Code' },
        { accessor: 'etos', Header: 'ETOS', editable: true },
    ];

    return (
        <div>
            <h1>DBI Cross Docks</h1>
            <Notifications options={notification} />
            <div>
                <DataTable columns={columns} data={rows} editable saveEdit={saveEdit} />
            </div>
        </div>
    );
}

export { DBICrossDocks };
